<template>
  <BAutocompleteSelect
    ref="autocomplete"
    v-bind="$attrs"
    label="Типы файлов"
    no-data-text="Тип не найден"
    :options="options"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { RoadmapBaseEventFileTypes } from '@/typings/api/RoadmapBaseEvent'

import BAutocompleteSelect from './BAutocompleteSelect.vue'


export default {
  name: 'BAutocompleteFileType',
  components: {
    BAutocompleteSelect,
  },
  mixins: [
    openApiMixin,
  ],
  data: () => ({
    options: Object.values(RoadmapBaseEventFileTypes),
  }),
}
</script>
